/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Exporting_ToastInputs */

const en_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting video export... encoding subtitles.`)
};

const fr_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage de l'exportation video... encodage des sous-titres.`)
};

const de_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoexport wird gestartet... Untertitel werden codiert.`)
};

const it_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'esportazione video... codifica dei sottotitoli.`)
};

const ru_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало экспорта видео... кодирование субтитров.`)
};

const es_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando exportación de video... codificando subtítulos.`)
};

const zh_cn2_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导出视频……正在编码字幕。`)
};

const ja_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポートを開始しています...字幕をエンコードしています。`)
};

const hi_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात शुरू हो रहा है... उपशीर्षक एन्कोड किए जा रहे हैं।`)
};

const pt_pt2_video_export_exporting_toast = /** @type {(inputs: Video_Export_Exporting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a exportação do vídeo... codificando legendas.`)
};

/**
* | output |
* | --- |
* | "Starting video export... encoding subtitles." |
*
* @param {Video_Export_Exporting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_exporting_toast = /** @type {((inputs?: Video_Export_Exporting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Exporting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_exporting_toast(inputs)
	if (locale === "de") return de_video_export_exporting_toast(inputs)
	if (locale === "it") return it_video_export_exporting_toast(inputs)
	if (locale === "ru") return ru_video_export_exporting_toast(inputs)
	if (locale === "es") return es_video_export_exporting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_exporting_toast(inputs)
	if (locale === "ja") return ja_video_export_exporting_toast(inputs)
	if (locale === "hi") return hi_video_export_exporting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_exporting_toast(inputs)
	return en_video_export_exporting_toast(inputs)
});